/* Hardline Tactical theme scripts: mobile nav, cart drawer, product gallery. */
(function () {
  var money = function (cents) {
    return '$' + (cents / 100).toFixed(2);
  };

  /* ---------------------------------------------------------------- nav -- */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-nav-toggle]');
    if (!toggle) return;
    var nav = document.getElementById('MobileNav');
    if (!nav) return;
    var open = nav.hasAttribute('hidden');
    if (open) nav.removeAttribute('hidden');
    else nav.setAttribute('hidden', '');
    toggle.setAttribute('aria-expanded', String(open));
  });

  /* -------------------------------------------------------------- drawer -- */
  function openDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-open]')) {
      event.preventDefault();
      openDrawer();
    }
    if (event.target.closest('[data-cart-close]')) {
      event.preventDefault();
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  /* ---------------------------------------------------------------- cart -- */
  function renderCart(cart) {
    var count = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < count.length; i++) {
      count[i].textContent = cart.item_count;
      if (cart.item_count > 0) count[i].removeAttribute('hidden');
      else count[i].setAttribute('hidden', '');
    }

    var total = document.querySelector('[data-cart-total]');
    if (total) total.textContent = money(cart.total_price);

    var body = document.querySelector('[data-cart-lines]');
    var foot = document.querySelector('[data-cart-foot]');
    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML =
        '<p class="small-muted" style="text-align:center;padding:3rem 0">Your cart is empty.</p>';
      if (foot) foot.setAttribute('hidden', '');
      return;
    }
    if (foot) foot.removeAttribute('hidden');

    body.innerHTML = cart.items
      .map(function (item) {
        var img = item.image
          ? '<img src="' +
            item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') +
            '" alt="' +
            item.product_title.replace(/"/g, '&quot;') +
            '">'
          : '';
        var variant =
          item.variant_title && item.variant_title !== 'Default Title'
            ? '<p class="small-muted">' + item.variant_title + '</p>'
            : '';
        return (
          '<div class="cart-line">' +
          '<div class="cart-line__media">' +
          img +
          '</div>' +
          '<div style="flex:1;min-width:0">' +
          '<p class="cart-line__title">' +
          item.product_title +
          '</p>' +
          variant +
          '<p class="small-muted">' +
          money(item.final_price) +
          '</p>' +
          '<div class="qty" style="margin-top:.5rem">' +
          '<button type="button" data-cart-qty="' +
          item.key +
          '" data-qty="' +
          (item.quantity - 1) +
          '" aria-label="Decrease quantity">&minus;</button>' +
          '<input type="text" value="' +
          item.quantity +
          '" readonly aria-label="Quantity">' +
          '<button type="button" data-cart-qty="' +
          item.key +
          '" data-qty="' +
          (item.quantity + 1) +
          '" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '</div>' +
          '<button type="button" class="cart-line__remove" data-cart-qty="' +
          item.key +
          '" data-qty="0">Remove</button>' +
          '</div>'
        );
      })
      .join('');
  }

  function refreshCart() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' },
    })
      .then(function (r) {
        return r.json();
      })
      .then(renderCart)
      .catch(function () {});
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(renderCart);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-cart-qty]');
    if (!btn) return;
    event.preventDefault();
    changeLine(btn.getAttribute('data-cart-qty'), parseInt(btn.getAttribute('data-qty'), 10));
  });

  /* --------------------------------------------------------- add to cart -- */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    var button = form.querySelector('[type="submit"]');
    if (button) button.setAttribute('disabled', '');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function () {
        return refreshCart();
      })
      .then(function () {
        openDrawer();
      })
      .catch(function () {})
      .finally(function () {
        if (button) button.removeAttribute('disabled');
      });
  });

  /* ------------------------------------------------------------- gallery -- */
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-gallery-main]');
    if (main) {
      main.src = thumb.getAttribute('data-full');
      main.alt = thumb.getAttribute('data-alt') || main.alt;
    }
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (el) {
      el.setAttribute('aria-current', String(el === thumb));
    });
  });

  /* ------------------------------------------------------- variant picker -- */
  document.addEventListener('change', function (event) {
    var picker = event.target.closest('[data-variant-picker]');
    if (!picker) return;
    var root = picker.closest('[data-product-root]');
    if (!root) return;
    var data = JSON.parse(root.querySelector('[data-variant-json]').textContent);
    var selected = Array.prototype.map.call(root.querySelectorAll('[data-variant-picker]'), function (el) {
      return el.value;
    });
    var match = data.find(function (variant) {
      return variant.options.every(function (option, index) {
        return option === selected[index];
      });
    });
    var idInput = root.querySelector('[name="id"]');
    var priceEl = root.querySelector('[data-variant-price]');
    var submit = root.querySelector('[data-product-form] [type="submit"]');
    if (match) {
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (submit) {
        if (match.available) {
          submit.removeAttribute('disabled');
          submit.textContent = submit.getAttribute('data-add-label') || 'Add to cart';
        } else {
          submit.setAttribute('disabled', '');
          submit.textContent = 'Sold out';
        }
      }
    }
  });

  /* ---------------------------------------------------------------- qty -- */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-qty-step]');
    if (!btn) return;
    var input = btn.parentNode.querySelector('input');
    if (!input) return;
    var next = parseInt(input.value, 10) + parseInt(btn.getAttribute('data-qty-step'), 10);
    input.value = String(Math.max(1, next));
  });

  document.addEventListener('DOMContentLoaded', refreshCart);
})();
